import { Injectable, ElementRef } from '@angular/core';

@Injectable()
export class LoadingSpinnerService {

  private appComponentRef: ElementRef;

  public setAppComponentRef(ref: ElementRef) {
    this.appComponentRef = ref;
  }
    constructor() {
  
    }

    showSpinner(){
      if (this.appComponentRef)
        this.appComponentRef.nativeElement.querySelector("#overlayWithSpinner").classList.add('visible');
    }

    hideSpinner(){
      if (this.appComponentRef)
        this.appComponentRef.nativeElement.querySelector("#overlayWithSpinner").classList.remove('visible');
    }


  }



// WEBPACK FOOTER //
// ./src/app/shared/services/loading-spinner.service.ts